import { render, staticRenderFns } from "./ProductIdea.vue?vue&type=template&id=63932d52"
import script from "./ProductIdea.vue?vue&type=script&lang=js"
export * from "./ProductIdea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports